import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { diagnosisSymptomsData } from '__mocks__/mockData/diagnosis-symptoms-data';

const DiagnosisSymptomsApi = [
  rest.get(`${API_ROOT}diagnosis-symptoms`, (req, res, ctx) => {
    const patientFriendlyName = req.url.searchParams.get('patientFriendlyName');
    if (patientFriendlyName === 'Chronic') {
      return res(ctx.json({ data: [diagnosisSymptomsData.data[0]], total: 1 }));
    }
    return res(ctx.json(diagnosisSymptomsData));
  }),
  rest.get(`${API_ROOT}diagnosis-symptoms/${diagnosisSymptomsData.data[0].id}`, (req, res, ctx) => res(ctx.json(diagnosisSymptomsData.data[0]))),
  rest.put(`${API_ROOT}diagnosis-symptoms/${diagnosisSymptomsData.data[0].id}`, (req, res, ctx) => res(ctx.json(diagnosisSymptomsData.data[0]))),
  rest.patch(`${API_ROOT}diagnosis-symptoms/${diagnosisSymptomsData.data[0].id}`, (req, res, ctx) => res(ctx.json(diagnosisSymptomsData.data[0]))),
  rest.post(`${API_ROOT}diagnosis-symptoms`, (req, res, ctx) => res(ctx.json(diagnosisSymptomsData.data[0]))),
];
export default DiagnosisSymptomsApi;
